module.exports = __webpack_public_path__ + "fr.svg?f4529ed89ccd5521b6895e298346e71d";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/fr.svg
// module id = 1359
// module chunks = 0